import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { usePostProductMutation, useUploadProductImageMutation, useGetAllCategoriesQuery } from "../../services/productApi";
import "./productForm.css";
import { DriveFolderUpload } from "@mui/icons-material";
import {
  AdminPageHeader,
  AdminCard,
  AdminInput,
  AdminSelect,
  LoadingButton,
  useToast,
} from "../../components/ui";

function NewProduct() {
  const navigate = useNavigate();
  const [server_error, setServerError] = useState({});
  const [postProduct, { isLoading }] = usePostProductMutation();
  const [uploadProductImage] = useUploadProductImageMutation();
  const { data: categories, isLoading: categoriesLoading } = useGetAllCategoriesQuery();
  const toast = useToast();

  const [imge, setImge] = useState({
    image1: '', image2: '', image3: '', image4: '',
  });

  const [data, setData] = useState({
    name: '',
    is_active: true,
    price: '',
    stock_quantity: '',
    description: '',
    sku: '',
    barcode: '',
    image1: '', image2: '', image3: '', image4: '',
    category: '',
  });

  const handleChange = event => {
    const name = event.target.name;
    const value = event.target.value;
    setData(values => ({ ...values, [name]: value }));
  };

  const handleImage = event => {
    const name = event.target.name;
    const value = event.target.files[0];
    setImge(values => ({ ...values, [name]: value }));
    const objectUrl = URL.createObjectURL(value);
    setData(values => ({ ...values, [name]: objectUrl }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const res = await postProduct({
      name: data.name,
      description: data.description,
      category: data.category,
      is_active: true,
      sku: data.sku,
      barcode: data.barcode || null,
      price: data.price,
      stock_quantity: data.stock_quantity,
    });

    if (res.error) {
      setServerError(res.error.data?.errors || res.error.data || {});
      toast.error("Could not add this product. Check the fields below.");
      return;
    }

    if (res.data) {
      const productId = res.data.id;
      let sortOrder = 0;
      for (const key of ['image1', 'image2', 'image3', 'image4']) {
        if (imge[key]) {
          const formData = new FormData();
          formData.append('image', imge[key]);
          formData.append('sort_order', sortOrder++);
          await uploadProductImage({ productId, formData });
        }
      }
      toast.success("Product added successfully.");
      setTimeout(() => navigate('/admin/products'), 1200);
    }
  };

  return (
    <div>
      <AdminPageHeader
        title="New Product"
        breadcrumbs={[
          { label: "Dashboard", to: "/admin/dashboard" },
          { label: "Products", to: "/admin/products" },
          { label: "New" },
        ]}
      />
      <AdminCard>
        <form onSubmit={handleSubmit} className="productFormLayout">
          <div className="productFormLayout__photos">
            <div className="photoGrid">
              {['image1', 'image2', 'image3', 'image4'].map((key, i) => (
                <div className="productPhoto" key={key}>
                  <img src={data[key]} alt={`Product ${i + 1}`} />
                  <div className="uploadContainer">
                    <DriveFolderUpload sx={{ fontSize: "18px" }} />
                    <input type="file" name={key} onChange={handleImage} aria-label={`Upload photo ${i + 1}`} />
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="productFormLayout__fields">
            <AdminInput
              label="Product Name"
              name="name"
              value={data.name}
              onChange={handleChange}
              error={server_error.name?.[0]}
              required
            />
            <AdminInput
              label="Product Description"
              name="description"
              value={data.description}
              onChange={handleChange}
              error={server_error.description?.[0]}
            />
            <div className="productFormRow">
              <AdminInput label="SKU" name="sku" value={data.sku} onChange={handleChange} error={server_error.sku?.[0]} />
              <AdminInput label="Barcode (optional)" name="barcode" value={data.barcode} onChange={handleChange} error={server_error.barcode?.[0]} />
            </div>
            <div className="productFormRow">
              <AdminInput label="Price" name="price" type="number" value={data.price} onChange={handleChange} error={server_error.price?.[0]} required />
              <AdminInput label="Stock" name="stock_quantity" type="number" value={data.stock_quantity} onChange={handleChange} error={server_error.stock_quantity?.[0]} required />
            </div>
            <AdminSelect
              label="Category"
              name="category"
              value={data.category}
              onChange={handleChange}
              error={server_error.category?.[0]}
              required
              disabled={categoriesLoading}
            >
              <option value="" disabled>{categoriesLoading ? "Loading categories..." : "Select a category"}</option>
              {(categories || []).map((c) => (
                <option key={c.id} value={c.id}>{c.name}</option>
              ))}
            </AdminSelect>
            <div className="productFormActions">
              <LoadingButton type="submit" loading={isLoading} loadingLabel="Adding...">
                Add Product
              </LoadingButton>
            </div>
          </div>
        </form>
      </AdminCard>
    </div>
  );
}

export default NewProduct;
